import { Autocomplete, Button, Dialog, DialogActions, DialogContent, TextField, Typography } from '@mui/material';
import _ from 'lodash';
import React, { useState } from 'react';
import { useGetAllBillingTiers } from '../../services/react-query/billing_tiers';
import { headerTypographyProps } from '../../styles/sxStyling';
import { BillingTier } from '../../types/BillingTier';


// TODO abstract up commonalitites with event template

interface ITemplateModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onCreate: (tierUuid: string) => void;
}

export default function TierModal({ isOpen, onCancel, onCreate }: ITemplateModalProps) {
  const [selectedOption, setSelectedOption] = useState<BillingTier | null>(null);
  const { data, isLoading } = useGetAllBillingTiers({});

  const handleAdd = () => {
    if (!selectedOption) return;
    onCreate(selectedOption.uuid);
  };

  return (
    <Dialog open={isOpen} onClose={onCancel} fullWidth>
      <Typography {...headerTypographyProps} sx={{ m: 2 }}>
        Please choose which billing tier to use
      </Typography>
      <DialogContent>
        <Autocomplete<BillingTier>
          loading={isLoading}
          options={data?.data || []}
          onChange={(_, option) => setSelectedOption(option)}
          getOptionLabel={(template) => template.name}
          value={selectedOption}
          renderInput={(params) => <TextField {...params} autoFocus label="Billing Tier" />}
        />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="contained" disabled={!selectedOption} color="primary" onClick={handleAdd}>
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
}
